// eslint-disable-next-line import/prefer-default-export
export const BUGSNAG_API_KEY = process.env.REACT_APP_BUGSNAG_API_KEY
export const BUGSNAG_RELEASE_STAGE = process.env.REACT_APP_BUGSNAG_RELEASE_STAGE
